import actions from '../actions';

const initialState = {
    fetching: false,
    fetched: false,
    fetchFailed: false,
    saving: false,
    saved: false,
    saveFailed: false,
    mapList: []
}
export default function emailEnterpriseMap(state = initialState, action) {
    switch(action.type) {
        case actions.GET_EMAIL_ENTERPRISE_MAP_REQUEST:
            return Object.assign({}, state, {
                fetching: true, fetched: false, fetchFailed: false,
                statusText: null
            });
        case actions.GET_EMAIL_ENTERPRISE_MAP_SUCCESS:
            return Object.assign({}, state, {
                fetching: false, fetched: true, fetchFailed: false,
                mapList: action.emailEnterpriseMap
            });
        case actions.GET_EMAIL_ENTERPRISE_MAP_FAILED:
            return Object.assign({}, state, {
                fetching: false, fetched: false, fetchFailed: true,
                statusText: action.errorMessage
            });
        case actions.SAVE_EMAIL_ENTERPRISE_MAP_REQUEST:
            return Object.assign({}, state, {
                saving: true, saved: false, saveFailed: false
            });
        case actions.SAVE_EMAIL_ENTERPRISE_MAP_SUCCESS:
            return Object.assign({}, state, {
                saving: false, saved: true, saveFailed: true,
                mapList: [...action.mapList]
            });
        case actions.SAVE_EMAIL_ENTERPRISE_MAP_FAILED:
            return Object.assign({}, state, {
                saving: false, saved:false, saveFailed: true,
                statusText: action.errorMessage
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/emailEnterpriseMapReducer.js